import { useQuery } from "react-query";
import { ProductType } from "./_models";
import { getAllProductTypes } from "./_requests";
import { useProductTypesListingState } from "./_store";
import { filter } from "lodash";


export const useProductTypesListing = () => {

  const setProductTypes = useProductTypesListingState(state => state.setProductTypes);
  return useQuery<Array<ProductType>, Error>({
    queryKey: ['GETALLPRODUCTTYPES'],
    queryFn: async () => {
      const data = await getAllProductTypes();
      setProductTypes(filter(data, o => (! o?.deleted))); // Sync to Zustand on fresh fetch
      return data;
    },
    staleTime: 600000,   // keep fresh for 10 mins (no refetch)
    cacheTime: 600000,   // clear from cache after 10 mins to free mem
    refetchOnWindowFocus: false, // Prevent re-fetching on tab switch
  });
};
